import { render, staticRenderFns } from "./LiveInTheLabs.vue?vue&type=template&id=31bc0f68&scoped=true&"
import script from "./LiveInTheLabs.vue?vue&type=script&lang=js&"
export * from "./LiveInTheLabs.vue?vue&type=script&lang=js&"
import style0 from "./LiveInTheLabs.vue?vue&type=style&index=0&id=31bc0f68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bc0f68",
  null
  
)

export default component.exports